
import Vue from 'vue'
import store from '@/store'
import RegistrationStatus from '@/components/RegistrationStatus.vue'
import { formatAddress } from '@/utils/addresses'
import {
  GetAllMyArqanaHorseRegistrationDto,
  FindByIdMyArqanaHorseRegistrationDto,
  myRegistrationApi,
  UpdateRegistrationHorseRequest,
  MinimalPersonContact,
} from '@/api/auth/myHorseRegistration'
import { handleAxiosException, handleAxiosExceptionOnBlobType } from '@/api'
import { defaultPage, Page } from '@/types'
import { formatBetween, formatDateTime, formatDate } from '@/utils/dates'
import { saleApi, SaleWithRegistrationsDto } from '@/api/sales'
import { cloneDeep, debounce } from 'lodash'
import countries, { getCountryLabel } from '@/utils/countries'
import { getBreedsLabel, availableBreeds } from '@/utils/breeds'
import { getRobesLabel, availableRobes } from '@/utils/robes'
import { horseTypesGalop, horseTypesTrot, getHorseTypeLabel } from '@/utils/horseType'
import { RoleType, roleTypes } from '@/utils/roleType'
import genders, { getGenderLabel } from '@/utils/genders'
import { formatPhoneNumber } from '@/utils/phone'
import protrusionFormulas from '@/utils/protrusionFormula'
import KAutocomplete from '@/components/shared/KAutocomplete.vue'
import { formatISO } from 'date-fns'
import add from 'date-fns/esm/add'
import parseISO from 'date-fns/fp/parseISO/index'
import { headerApi } from '@/api/header'
import { placeToVisitApi, PlaceToVisitDto } from '@/api/placeToVisit'
import { lotSellerApi } from '@/api/lotSeller'
import DatePicker from '@/components/shared/DatePicker.vue'
import { Horse } from '@/api/ifce'
import horseStatuses from '@/utils/horseStatus'
import { isRequiredGenerator, validMicrochipIdRule, validSireIdRule } from '@/utils/rules'
import { horseApi, MinimalHorseDto } from '@/api/horse'
import snackbarStore from '@/store/snackbarStore'
import { AxiosResponse } from 'axios'
import RegistrationStepper from './RegistrationStepper.vue'
import OwnerRegistration from './owner/OwnerRegistration.vue'

export default Vue.extend({
  name: 'Registrations',
  components: { RegistrationStepper, RegistrationStatus, OwnerRegistration, KAutocomplete, DatePicker },
  props: {
    old: { type: Boolean, default: false },
  },
  data() {
    return {
      error: '',
      loading: false,
      editDialog: {
        active: false,
        placeToVisit: undefined as undefined,
      },
      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
      registrationsWaiting: {
        content: [],
        totalElements: 0,
        totalPages: 0,
        page: 0,
        size: 0,
      } as Page<FindByIdMyArqanaHorseRegistrationDto>,
      lengthPagination: 1,
      salesToView: { content: [], totalElements: 0, totalPages: 0, page: 0, size: 0 } as Page<SaleWithRegistrationsDto & {
        expanded: boolean,
        expandedRegistrations: Page<FindByIdMyArqanaHorseRegistrationDto>
      }>,
      sizePageWaitingRegistrations: 10,
      sizePageRegistrationsSale: 20,
      sizePageSales: 2,
      saleToView: {
        sale: { id: 0, name: '', startDate: '', endDate: '' },
        registrations: defaultPage,
      } as SaleWithRegistrationsDto,
      dialogSale: false,
      saleId: 0,
      loadingRegistrationsSale: false,
      loadingRegistration: false,
      errorLoadingRegistrationsSale: '',
      searchInRegistrationSale: '',
      searchByName: '',
      searchByRoles: [] as RoleType[],
      searchByTypes: [],
      searchByExposingDays: [],
      pageRegistrationsSale: 1,
      debouncedSearchHorse: debounce((callback: (value: string) => void, value: string) => {
        callback(value)
      }, 600),
      registrationDialog: false,
      registrationToView: {} as GetAllMyArqanaHorseRegistrationDto,
      errorLoadingRegistration: '',
      registrationDetailSection: false,
      store,
      ownerChangeDialog: false,
      ownerChangeRegistrationId: undefined as undefined | number,
      valid: true,
      updateDialog: false,
      updateLoading: false,
      loadingPedigree: false,
      registrationToUpdate: {} as GetAllMyArqanaHorseRegistrationDto,
      sireMenu: {
        loading: false,
        horse: undefined as Horse | undefined,
        debounce: debounce((callback: (value: string) => void, value: string) => {
          callback(value)
        }, 500),
        error: undefined as string | undefined,
      },
      microchipMenu: {
        loading: false,
        horse: undefined as Horse | undefined,
        debounce: debounce((callback: (value: string) => void, value: string) => {
          callback(value)
        }, 500),
        error: undefined as string | undefined,
        warning: undefined as string | undefined,
        success: undefined as string | undefined,
      },
      breeds: availableBreeds,
      robes: availableRobes,
      genders,
      countries,
      horseStatuses,
      horseTypes: process.env.VUE_APP_IS_TROT ? horseTypesTrot : horseTypesGalop,
      roleTypes,
      protrusionFormulas,
      stallion: {},
    }
  },
  methods: {
    formatAddress,
    formatBetween,
    formatDateTime,
    formatDate,
    formatPhoneNumber,
    isRequiredGenerator,
    validMicrochipIdRule,
    validSireIdRule,
    async queryStallion(name: string) {
      if (name != null) {
        const page = { page: 0, size: 20, sort: [] }
        return (await horseApi.getAll({ name, gender: ['MALE', 'HONGRE'] }, page)).content
      } else {
        return []
      }
    },
    formatHorse(h: MinimalHorseDto) {
      if (h) {
        if (!h.birthday && !h.father?.name) {
          return h.name
        }
        return `${h.name} - ${h.birthday.slice(0, 4)} (${h.father?.name})`
      } else {
        return ''
      }
    },
    async callbackHeaders(filter: string) {
      return (await headerApi.getAllHeaders({ size: 20, name: filter })).content
    },
    async callbackPlaceToVisits(filter: string) {
      return (await placeToVisitApi.getAllPlacesToVisit({ size: 20, name: filter })).content
    },
    formatNamePlaceToVisit(placeToVisit: PlaceToVisitDto) {
      return placeToVisit.name ? placeToVisit.name : placeToVisit.fullName
    },
    async callbackOwners(filter: string) {
      return (await lotSellerApi.getAllLotSellers({ size: 20, name: filter })).content
    },
    removeOwner(i: number) {
      this.registrationToUpdate.owners.splice(i, 1)
    },
    addOwner() {
      const ls = {} as MinimalPersonContact
      this.registrationToUpdate.owners.push({ lotSeller: ls, part: 100 })
    },
    setPageWaiting(page: number) {
      if (page !== this.pageWaiting) {
        this.$router.push({ query: { pageWaiting: page.toString(), pageSales: this.pageSales.toString() } })
      }
    },
    setPageSales(page: number) {
      if (page !== this.pageSales) {
        this.$router.push({ query: { pageWaiting: this.pageWaiting.toString(), pageSales: page.toString() } })
      }
    },
    create() {
      this.editDialog = {
        active: true,
        placeToVisit: undefined,
      }
    },
    async loadData() {
      this.loading = true
      try {
        await Promise.all([
          myRegistrationApi.getAllWithDocuments(this.old ? { old: true } : { states: ['WAITING', 'NOT_COMPLETED', 'REFUSED'], name: this.searchByName, types: this.searchByTypes, exposingDays: this.searchByExposingDays }, { page: this.pageWaiting - 1, size: this.sizePageWaitingRegistrations, sort: ['technicalSale.startDate,ASC', 'lot.state,ASC', 'lot.number,ASC', 'name,ASC'] }).then(page => {
            this.registrationsWaiting = page
          }),
          saleApi.getAllTechnicalSalesForRegistrations({
            page: this.pageSales - 1,
            size: this.sizePageSales,
            sort: ['startDate,DESC'],
          }).then(data => {
            this.salesToView = {
              ...data,
              content: data.content.map(e => ({
                ...e,
                expanded: false,
                expandedRegistrations: {} as Page<FindByIdMyArqanaHorseRegistrationDto>,
              })),
            }
            if (this.saleId > 0) {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              this.saleToView.sale = this.salesToView.content.find(el => el.sale.id === this.saleId)!.sale
            }
          }),
        ])
      } catch (err) {
        this.error = handleAxiosException(err)
      }
      this.loading = false
    },
    async loadRegistrationSale() {
      this.dialogSale = true
      this.loadingRegistrationsSale = true
      this.errorLoadingRegistrationsSale = ''
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (this.salesToView.content.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.saleToView.sale = this.salesToView.content.find(el => el.sale.id === this.saleId)!.sale
      }
      await myRegistrationApi.getAllWithDocuments({
        saleId: this.saleId,
        name: this.searchInRegistrationSale,
      }, { page: this.pageRegistrationsSale - 1, size: this.sizePageRegistrationsSale }).then(v => {
        this.saleToView.registrations = v
      }).catch(e => {
        this.errorLoadingRegistrationsSale = handleAxiosException(e)
      })
      this.loadingRegistrationsSale = false
    },
    async loadRegistrationsWaiting() {
      this.loadingRegistration = true
      this.errorLoadingRegistration = ''
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filters: any = { name: this.searchByName, types: this.searchByTypes, exposingDays: this.searchByExposingDays, roles: this.searchByRoles }
      if (this.old) {
        filters.old = true
      } else {
        filters.state = ['WAITING', 'NOT_COMPLETE', 'REFUSED']
      }
      await myRegistrationApi.getAllWithDocuments(filters, {
        page: this.pageWaiting - 1,
        size: this.sizePageWaitingRegistrations,
      }).then(v => {
        this.registrationsWaiting = v
      }).catch(e => {
        this.errorLoadingRegistration = handleAxiosException(e)
      })
      this.loadingRegistration = false
    },
    seeRegistrationbySaleId(id: number) {
      this.saleId = id
      this.loadRegistrationSale()
    },
    onSearchInRegistrationSaleChange() {
      this.loadingRegistrationsSale = true
      this.pageRegistrationsSale = 1
      this.debouncedSearchHorse(this.loadRegistrationSale, '')
    },
    onSearchChange() {
      this.loadingRegistration = true
      this.pageWaiting = 1
      this.debouncedSearchHorse(this.loadRegistrationsWaiting, '')
    },
    async showRegistration(r: GetAllMyArqanaHorseRegistrationDto) {
      this.loadingRegistration = true
      this.registrationDialog = true
      this.errorLoadingRegistration = ''
      this.registrationToView = r
      await myRegistrationApi.findById(r.id).then(registrations => {
        this.registrationToView = registrations
      }).catch(e => {
        this.errorLoadingRegistration = handleAxiosException(e)
      })
      this.loadingRegistration = false
    },
    async updateRegistration() {
      if ((this.$refs.form as HTMLFormElement).validate()) {
        try {
          this.updateLoading = true
          const updateRequest = {
            microchipId: this.registrationToUpdate.microchipId,
            sireId: this.registrationToUpdate.sireId,
            birthday: this.registrationToUpdate.birthday,
            birthCountry: this.registrationToUpdate.birthCountry,
            robe: this.registrationToUpdate.robe,
            breed: this.registrationToUpdate.breed,
            gender: this.registrationToUpdate.gender,
            status: this.registrationToUpdate.horseStatus,
            protrusionFormula: this.registrationToUpdate.protrusionFormula,
            protrusionDate: this.registrationToUpdate.protrusionDate,
            stallion: this.registrationToUpdate.stallionId,
            associationContract: this.registrationToUpdate.associationContract,
            rentalContract: this.registrationToUpdate.rentalContract,
            headerId: this.registrationToUpdate.header?.id,
            placeToVisitId: this.registrationToUpdate.placeToVisit?.id,
            owners: this.registrationToUpdate.owners.map((o) => ({ lotSellerId: o.lotSeller.id, part: o.part })),
          } as UpdateRegistrationHorseRequest
          await myRegistrationApi.updateRegistration(this.registrationToUpdate.id, updateRequest)
          this.closeUpdate()
          snackbarStore.setSuccess(this.$t('form.success.update').toString())
          this.loadData()
        } catch (err) {
          snackbarStore.setError(this.$t(handleAxiosException(err, (r: AxiosResponse) => r.data?.message ?? 'form.error.global_error')).toString())
        } finally {
          this.updateLoading = false
        }
      }
    },
    closeUpdate() {
      this.updateDialog = false
      this.registrationToUpdate = {} as GetAllMyArqanaHorseRegistrationDto
    },
    async showUpdate(r: GetAllMyArqanaHorseRegistrationDto) {
      await myRegistrationApi.findById(r.id).then(registration => {
        this.stallion = { id: registration.stallionId, name: registration.stallionName }
        this.registrationToUpdate = cloneDeep(registration)
        // eslint-disable-next-line no-unused-expressions
        ;(this.$refs.form as HTMLFormElement | undefined)?.resetValidation()
      }).catch(e => {
        this.errorLoadingRegistration = handleAxiosException(e)
      })
      this.updateDialog = true
    },
    async showOwnerChange(r: GetAllMyArqanaHorseRegistrationDto) {
      this.ownerChangeRegistrationId = r.id
      this.ownerChangeDialog = true
    },
    isUpdateOpen(r: GetAllMyArqanaHorseRegistrationDto) {
      return !r.lotExist
    },
    isDocumentOpened(r: GetAllMyArqanaHorseRegistrationDto) {
      if (!['VISITED', 'COMPLETED'].includes(r.state) || this.old) {
        return false
      }
      const dateNow = formatISO(new Date(), { representation: 'date' })
      const startOpenDocumentUpload = formatISO(add(parseISO(r.technicalSale.startDate), { days: -30 }), { representation: 'date' })
      return dateNow < r.exposingDay && dateNow >= startOpenDocumentUpload
    },
    isPedigreeOpened(r: GetAllMyArqanaHorseRegistrationDto) {
      if (!['VISITED', 'COMPLETED'].includes(r.state) || this.old) {
        return false
      }
      const dateNow = formatISO(new Date(), { representation: 'date' })
      return dateNow <= r.technicalSale.correctionsEnd && dateNow >= r.technicalSale.correctionsStart && r.pedigreeAvailable && r.pedigreeUploaded
    },
    isPedigreeDownloadAllowed(r: GetAllMyArqanaHorseRegistrationDto) {
      const dateNow = formatISO(new Date(), { representation: 'date' })
      return r.technicalSale.correctionsEnd < dateNow && dateNow < r.technicalSale.startDate && r.pedigreeAvailable
    },
    isResourceOpened(r: GetAllMyArqanaHorseRegistrationDto) {
      return !(!['VISITED', 'COMPLETED'].includes(r.state) || this.old)
    },
    isOwnerChangeOpened(r: GetAllMyArqanaHorseRegistrationDto) {
      const dateNow = formatISO(new Date(), { representation: 'date' })
      return (r.technicalSaleState === 'IMPRESSION' || r.technicalSaleState === 'FIGEE') && !r.sellerValidatedTime && dateNow < r.technicalSale.startDate
    },
    async downloadPedigree(r: GetAllMyArqanaHorseRegistrationDto) {
      this.error = ''
      this.loadingPedigree = true
      try {
        await myRegistrationApi.downloadOriginalPedigreePdf(r.id)
      } catch (err) {
        snackbarStore.setError(await handleAxiosExceptionOnBlobType(err))
      }
      this.loadingPedigree = false
    },
    getCountryLabel,
    getBreedsLabel,
    getRobesLabel,
    getHorseTypeLabel,
    getGenderLabel,
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  computed: {
    pageWaiting() {
      return parseInt(this.$route.query.pageWaiting as string ?? '1', 10)
    },
    pageSales() {
      return parseInt(this.$route.query.pageSales as string ?? '1', 10)
    },
    sale() {
      return parseInt(this.$route.query.sale as string ?? '0', 10)
    },
    visitRule() {
      if (this.registrationToUpdate.type === 'YEARLING' || this.registrationToUpdate.type === 'STORE2' || this.registrationToUpdate.type === 'STORE3') {
        return [isRequiredGenerator(this.$t('form.place-to-visit.required').toString())]
      } else {
        return []
      }
    },
    ruleAllPartBelow100(): undefined | string {
      if (this.registrationToUpdate.owners.reduce((p, c) => p + c.part, 0) === 100) {
        return undefined
      } else {
        return 'La somme totale des parts doit être égale à 100%'
      }
    },
    isPercentageStrictPositive() {
      return (v: number) => v >= 1 && v <= 100 || 'La valeur doit être comprise entre 1 et 100'
    },
    duplicateOwners(): boolean {
      return new Set(this.registrationToUpdate.owners.map(o => o.lotSeller.id)).size === this.registrationToUpdate.owners.length
    },
  },
  watch: {
    pageWaiting() {
      this.loadData()
    },
    pageSales() {
      this.loadData()
    },
    old() {
      this.loadData()
    },
    sale: {
      handler(v) {
        if (v) {
          this.seeRegistrationbySaleId(v)
        } else {
          this.dialogSale = false
          this.saleId = 0
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.loadData()
  },
})
